// extracted by mini-css-extract-plugin
export default {"container":"style_container__Xa7sp","header":"style_header__sX2ih","content":"style_content__y2nV2"};